import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import {
  DataQualityTestConfigurationPayload,
  DataQualityTestConfigurationResponse,
  DataQualityTestResult,
} from '../model/DataQualityTestModel';

export default class DataQualityTestController extends AuthenticatedController {
  static async getConfiguration(
    facebookPageId?: number,
  ): Promise<DataQualityTestConfigurationResponse> {
    return super.get(APIRoutes.DATA_QUALITY_TEST_CONFIGURATION, {
      facebook_page_id: facebookPageId,
    });
  }

  static createConfiguration(
    config: DataQualityTestConfigurationPayload,
  ): Promise<DataQualityTestConfigurationResponse> {
    return super.post(APIRoutes.DATA_QUALITY_TEST_CONFIGURATION, config);
  }

  static updateConfiguration(
    config: Partial<DataQualityTestConfigurationPayload>,
  ): Promise<DataQualityTestConfigurationResponse> {
    return super.put(APIRoutes.DATA_QUALITY_TEST_CONFIGURATION, config);
  }

  static getResult(facebookPageId?: number): Promise<DataQualityTestResult> {
    return super.get(APIRoutes.DATA_QUALITY_TEST_RESULT, {
      facebook_page_id: facebookPageId,
    });
  }
}
